import React from "react";
import { useTranslation } from "react-i18next";
import CasesEmergeny from "assets/CasesEmergeny";
import CasesHigh from "assets/CasesHigh";
import CasesMedium from "assets/CasesMedium";
import CasesLow from "assets/CasesLow";
import CasesInformational from "assets/CasesInformational";
import HelpCircleIcon from "assets/HelpCircleIcon";

import {
  StyledTopGridNumber,
  StyledTopGridType,
  StyledTopContainer,
  StyledIcon
} from "./gridPageLayout.styled";

interface TopGridBoxProps {
  num?: number;
  type?: string;
  iconName?: string;
  color?: string;
}

const TopGridBox = ({ color, num, type, iconName }: TopGridBoxProps) => {
  const { t } = useTranslation();

  const renderIcon = (icon?: string): JSX.Element => {
    switch (icon) {
      case t("SEVERITY.LOW"):
        return <CasesLow />;
      case t("SEVERITY.MEDIUM"):
        return <CasesMedium />;
      case t("SEVERITY.HIGH"):
        return <CasesHigh />;
      case t("SEVERITY.CRITICAL"):
        return <CasesEmergeny />;
      case t("SEVERITY.INFORMATIVE"):
        return <CasesInformational />;
      case t("SEVERITY.UNCLASSIFIED"):
        return <HelpCircleIcon />;
      default:
        return <></>;
    }
  };

  return (
    <StyledTopContainer className="pt-3 ps-4 pb-3" elevation={1}>
      <StyledTopGridNumber>{num}</StyledTopGridNumber> 
      <StyledTopGridType>
        <p>{type}</p>
        {iconName && (
          <StyledIcon>{renderIcon(iconName)}</StyledIcon>
        )}
      </StyledTopGridType>
    </StyledTopContainer>
  );
};

export default TopGridBox;
